import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { TruncateNum } from '../../../Components/truncateNumber';
import { MyLibraryLogIn, GetFormContextOfUse, GetUEN, GetFormPurposeOfUse, GetPriceRule } from './module';

const initialState = {
    status: "idle",
    isCaptcha: true,
    dateFrom: null,
    dataUrl: null,
    contextOfUse: null,
    Uens: null,
    filterAgencyValue: "",
    cur_agency: sessionStorage.getItem('afs') && JSON.parse(sessionStorage.getItem('afs')).UserTypeCode === 'PA' ? JSON.parse(sessionStorage.getItem('afs')).OrganisationName : '',
    isDateWithin3Years: true,
    selectDays: 0,
    isNumberCorrect: true,
    curPOU: sessionStorage.getItem('afs') ? JSON.parse(sessionStorage.getItem('afs')).UserTypeCode : 'PU',
    curCOU: sessionStorage.getItem('afs') ? JSON.parse(sessionStorage.getItem('afs')).COUCode : 'AD',
    shoppingCart: sessionStorage.getItem('shoppingCart') ? JSON.parse(sessionStorage.getItem('shoppingCart')) : null,
    PriceRules: null,
    purposeOfUse: null,
    ActionStatus: "",
    errorMessage: ""
};

export const MyLibraryLogInAsync = createAsyncThunk(
    'archivalForm/MyLibraryLogIn',
    async (data, ThunkAPI) => {
        const response = await MyLibraryLogIn(data);
        return response;
    }
);

export const GetFormContextOfUseAsync = createAsyncThunk(
    'archivalForm/GetFormContextOfUse',
    async (data, ThunkAPI) => {
        const response = await GetFormContextOfUse(data);
        return response;
    }
);

export const GetUENAsync = createAsyncThunk(
    'archivalForm/GetUEN',
    async (data, ThunkAPI) => {
        const response = await GetUEN(data);
        return response;
    }
);

export const GetPriceRuleAsync = createAsyncThunk(
    'archivalForm/GetPriceRule',
    async (data, ThunkAPI) => {
        const response = await GetPriceRule();
        const resultPromise = Promise.resolve(response);
        resultPromise.then((data, index) => {
            if (data && data.Status === 'OK') {
                if (sessionStorage.getItem('shoppingCart')) {
                    ThunkAPI.dispatch(GetFormPurposeOfUseAsync());
                }
            }
        })
        return response;
    }
);

export const GetFormPurposeOfUseAsync = createAsyncThunk(
    'archivalForm/GetFormPurposeOfUse',
    async (data, ThunkAPI) => {
        const response = await GetFormPurposeOfUse();
        const resultPromise = Promise.resolve(response);
        resultPromise.then((data, index) => {
            if (data && data.Status === 'OK') {
                ThunkAPI.dispatch(CountAAFees(data.PurposeOfUses));
            }
        })
        return response;
    }
);

export const archivalFormSlice = createSlice({
    name: 'archivalForm',
    initialState,
    reducers: {
        captchaChecked: (state, action) => {
            state.isCaptcha = action.payload;
        },
        validateNumber: (state, action) => {
            state.isNumberCorrect = action.payload;
        },
        saveDateFrom: (state, action) => {
            state.dateFrom = action.payload;
        },
        validateDate: (state, action) => {
            state.isDateWithin3Years = action.payload.is3years;
            state.selectDays = action.payload.days;
        },
        ChangePOU: (state, action) => {
            state.curPOU = action.payload
        },
        UpdateCouData: (state, action) => {
            state.curCOU = action.payload
        },
        filterAgencyList: (state, action) => {
            state.filterAgencyValue = action.payload
        },
        GetAgency: (state, action) => {
            state.cur_agency = action.payload
        },
        CountAAFees: (state, action) => {
            var rules = action.payload;

            // var lengthOfPhyAndDigWithSameAcc = $.grep(state.shoppingCart.availableAfterPayment.accessionNumbers, function (element) {
            //     return $.inArray(element, state.shoppingCart.availableAfterPayment.physicalAccessionNumbers) !== -1;
            // });
            //state.shoppingCart.gst = state.shoppingCart.gstRate;
            state.shoppingCart.gst = parseInt(process.env.REACT_APP_GST);;
            //state.shoppingCart.subjectToApproval.minusAmount = 0;
            //state.shoppingCart.availableAfterPayment.minusAmount = 0;
            state.shoppingCart.subjectToApproval.totalAafee = 0;
            state.shoppingCart.availableAfterPayment.totalAafee = 0;
            state.shoppingCart.subjectToApproval.totalAafeeGST = 0;
            state.shoppingCart.availableAfterPayment.totalAafeeGST = 0;
            state.shoppingCart.aafee = 0;
            state.shoppingCart.aafeeGST = 0;

            state.shoppingCart.subjectToApproval.totalItemsAmountAndTotalAafee = 0;
            state.shoppingCart.subjectToApproval.gstAmount = 0;
            state.shoppingCart.subjectToApproval.finalAmount = 0;

            state.shoppingCart.availableAfterPayment.totalItemsAmountAndTotalAafee = 0;
            state.shoppingCart.availableAfterPayment.gstAmount = 0;
            state.shoppingCart.availableAfterPayment.finalAmount = 0;

            state.countPhysical = 0;
            state.countPhysicalItemPice = 0;
            state.PayNowCount = state.shoppingCart.availableAfterPayment.items.length;

            var AP_items = state.shoppingCart.availableAfterPayment.items;
            AP_items.forEach((item) => {
                if (item.Format === "PHY") {
                    state.countPhysical += 1;
                    state.countPhysicalItemPice += item.Price;
                }
            });

            state.countDigital = state.PayNowCount - state.countPhysical;

            var lengthOfPhyAndDigWithSameAcc = state.shoppingCart.availableAfterPayment.accessionNumbers.filter((data) => state.shoppingCart.availableAfterPayment.physicalAccessionNumbers.includes(data));

            rules.forEach(function (rule) {
                if ((!rule.UserTypeCode || rule.UserTypeCode === state.curPOU) && (!rule.COUCode || rule.COUCode === state.curCOU)) {
                    var comOrNcm = rule.Value;

                    state.PriceRules.forEach(function (price) {

                        if (price.PurposeOfUse === comOrNcm) {
                            state.AAfee = parseFloat(price.SetPrice).toFixed(2);
                            state.AAfeeGST = TruncateNum(price.GSTPrice.toFixed(2));

                            //SA AAFee
                            state.shoppingCart.subjectToApproval.totalAafee = parseFloat(state.AAfee * state.shoppingCart.subjectToApproval.accessionNumbers.length).toFixed(2);
                            state.shoppingCart.subjectToApproval.totalAafeeGST = parseFloat(state.AAfeeGST * state.shoppingCart.subjectToApproval.accessionNumbers.length).toFixed(2);
                            //AP AAFee
                            state.getNewPhysicalAccLength = (state.countPhysical - lengthOfPhyAndDigWithSameAcc.length);
                            state.shoppingCart.availableAfterPayment.totalAafee = state.AAfee * (state.shoppingCart.availableAfterPayment.accessionNumbers.length);
                            state.shoppingCart.availableAfterPayment.totalAafeeGST = state.AAfeeGST * (state.shoppingCart.availableAfterPayment.accessionNumbers.length);

                            state.shoppingCart.aafee = state.AAfee;
                            state.shoppingCart.aafeeGST = state.AAfeeGST;

                            if (state.curPOU !== 'PA') {
                                //SA FEE
                                state.shoppingCart.subjectToApproval.totalItemsAmountAndTotalAafee = parseFloat(parseFloat(state.shoppingCart.subjectToApproval.totalItemsAmount) - parseFloat(state.shoppingCart.subjectToApproval.minusAmount) + parseFloat(state.shoppingCart.subjectToApproval.totalAafee)).toFixed(2);
                                state.shoppingCart.subjectToApproval.gstAmount = parseFloat(state.shoppingCart.subjectToApproval.totalAafeeGST) + (parseFloat(state.shoppingCart.subjectToApproval.totalWithGstAmount) ? parseFloat(parseFloat(state.shoppingCart.subjectToApproval.totalWithGstAmount).toFixed(2)) : 0);
                                state.shoppingCart.subjectToApproval.finalAmount = parseFloat(state.shoppingCart.subjectToApproval.totalItemsAmountAndTotalAafee) + parseFloat(state.shoppingCart.subjectToApproval.gstAmount);

                                //AP FEE
                                state.shoppingCart.availableAfterPayment.totalItemsAmountAndTotalAafee = parseFloat(state.shoppingCart.availableAfterPayment.totalItemsAmount) + parseFloat(state.shoppingCart.availableAfterPayment.totalAafee);
                                state.shoppingCart.availableAfterPayment.gstAmount = parseFloat(state.shoppingCart.availableAfterPayment.totalAafeeGST) + (parseFloat(state.shoppingCart.availableAfterPayment.totalWithGstAmount) ? parseFloat(parseFloat(state.shoppingCart.availableAfterPayment.totalWithGstAmount).toFixed(2)) : 0);
                                state.shoppingCart.availableAfterPayment.finalAmount = parseFloat(state.shoppingCart.availableAfterPayment.totalItemsAmountAndTotalAafee) + parseFloat(state.shoppingCart.availableAfterPayment.gstAmount);
                            } else {
                                //SA FEE
                                state.shoppingCart.subjectToApproval.totalItemsAmountAndTotalAafee = parseFloat(state.shoppingCart.subjectToApproval.totalItemsAmount) - parseFloat(state.shoppingCart.subjectToApproval.minusAmount) + parseFloat(state.shoppingCart.subjectToApproval.totalAafee);
                                state.shoppingCart.subjectToApproval.gstAmount = 0;
                                state.shoppingCart.subjectToApproval.finalAmount = 0;

                                //AP FEE
                                state.shoppingCart.availableAfterPayment.totalItemsAmountAndTotalAafee = state.shoppingCart.availableAfterPayment.totalItemsAmount + state.shoppingCart.availableAfterPayment.totalAafee;

                                if (state.countPhysical > 0) {
                                    state.shoppingCart.availableAfterPayment.gstAmount = state.shoppingCart.availableAfterPayment.totalWithGstAmount ? parseFloat(state.shoppingCart.availableAfterPayment.totalWithGstAmount) : 0;
                                    state.shoppingCart.availableAfterPayment.finalAmount = parseFloat(state.countPhysicalItemPice) + parseFloat(state.shoppingCart.availableAfterPayment.gstAmount);
                                } else {
                                    state.shoppingCart.availableAfterPayment.gstAmount = 0;
                                    state.shoppingCart.availableAfterPayment.finalAmount = 0;
                                }

                            }

                            // if (parseFloat(state.shoppingCart.subjectToApproval.gstAmount) > 0) state.shoppingCart.subjectToApproval.gstAmount = TruncateNum(state.shoppingCart.subjectToApproval.gstAmount);
                            if (parseFloat(state.shoppingCart.subjectToApproval.gstAmount) > 0) state.shoppingCart.subjectToApproval.gstAmount = parseFloat(state.shoppingCart.subjectToApproval.gstAmount).toFixed(2);
                            if (parseFloat(state.shoppingCart.subjectToApproval.finalAmount) > 0) state.shoppingCart.subjectToApproval.finalAmount = parseFloat(state.shoppingCart.subjectToApproval.finalAmount).toFixed(2);
                            if (parseFloat(state.shoppingCart.subjectToApproval.totalItemsAmountAndTotalAafee) > 0) state.shoppingCart.subjectToApproval.totalItemsAmountAndTotalAafee = parseFloat(state.shoppingCart.subjectToApproval.totalItemsAmountAndTotalAafee).toFixed(2);

                            if (parseFloat(state.shoppingCart.availableAfterPayment.totalItemsAmountAndTotalAafee) > 0) state.shoppingCart.availableAfterPayment.totalItemsAmountAndTotalAafee = parseFloat(state.shoppingCart.availableAfterPayment.totalItemsAmountAndTotalAafee).toFixed(2);
                            // if (parseFloat(state.shoppingCart.availableAfterPayment.gstAmount) > 0) state.shoppingCart.availableAfterPayment.gstAmount = TruncateNum(state.shoppingCart.availableAfterPayment.gstAmount);
                            if (parseFloat(state.shoppingCart.availableAfterPayment.gstAmount) > 0) state.shoppingCart.availableAfterPayment.gstAmount = parseFloat(state.shoppingCart.availableAfterPayment.gstAmount).toFixed(2);
                            if (parseFloat(state.shoppingCart.availableAfterPayment.finalAmount) > 0) state.shoppingCart.availableAfterPayment.finalAmount = parseFloat(state.shoppingCart.availableAfterPayment.finalAmount).toFixed(2);
                        }
                    })
                }

            })
            sessionStorage.setItem('shoppingCart', JSON.stringify(state.shoppingCart));
        }
    },
    extraReducers: (builder) => {
        builder.addCase(MyLibraryLogInAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(MyLibraryLogInAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(MyLibraryLogInAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.dataUrl = action.payload.LoginUrl;
            }
        });
        builder.addCase(GetFormContextOfUseAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(GetFormContextOfUseAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetFormContextOfUseAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.contextOfUse = action.payload.ContextOfUses;
            }
        });
        builder.addCase(GetUENAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(GetUENAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetUENAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.Uens = action.payload.Uens;
            }
        });
        builder.addCase(GetFormPurposeOfUseAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(GetFormPurposeOfUseAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetFormPurposeOfUseAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.purposeOfUse = action.payload ? action.payload.PurposeOfUses : null;
            }
        });
        builder.addCase(GetPriceRuleAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(GetPriceRuleAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetPriceRuleAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            state.PriceRules = action.payload ? action.payload.PriceRules : null;
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            }
        });

    }
});
export const { captchaChecked, validateNumber, saveDateFrom, validateDate, ChangePOU, filterAgencyList, GetAgency, CountAAFees, UpdateCouData } = archivalFormSlice.actions;
export const pagesState = (state) => state.archivalForm;
export const contextOfUse = (state) => state.archivalForm.contextOfUse;
export const Uens = (state) => state.archivalForm.Uens;
export const filterAgencyValue = (state) => state.archivalForm.filterAgencyValue;
export const shoppingCart = (state) => state.archivalForm.shoppingCart;
export const cur_agency = (state) => state.archivalForm.cur_agency;
export const curPOU = (state) => state.archivalForm.curPOU;
export const curCOU = (state) => state.archivalForm.curCOU;
export const myLibs = (state) => state.Session.myLibs;
export const formData = (state) => state.archivalSummary.archivalFormData;

export default archivalFormSlice.reducer;
